import { render, staticRenderFns } from "./videoTagList.vue?vue&type=template&id=c051aa5e&scoped=true"
import script from "./videoTagList.vue?vue&type=script&lang=js"
export * from "./videoTagList.vue?vue&type=script&lang=js"
import style0 from "./videoTagList.vue?vue&type=style&index=0&id=c051aa5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c051aa5e",
  null
  
)

export default component.exports